import React from 'react';
import './Common.css';

interface Column<T> {
  key: string;
  label: string;
  render?: (item: T) => React.ReactNode;
}

interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (item: T) => void;
  loading?: boolean;
  emptyMessage?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function DataTable<T = any>({ columns, data, onRowClick, loading, emptyMessage = '데이터가 없습니다' }: TableProps<T>) {
  if (loading) return <div className="table-loading">로딩 중...</div>;
  if (data.length === 0) return <div className="table-empty">{emptyMessage}</div>;

  return (
    <>
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>{columns.map(c => <th key={c.key}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={(item as Record<string, string>).id || String(i)} onClick={() => onRowClick?.(item)} className={onRowClick ? 'clickable' : ''}>
                {columns.map(c => (
                  <td key={c.key}>{c.render ? c.render(item) : (item as Record<string, unknown>)[c.key] as React.ReactNode}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="table-cards">
        {data.map((item, i) => (
          <div key={(item as Record<string, string>).id || String(i)} className="table-card" onClick={() => onRowClick?.(item)}>
            {columns.map(c => (
              <div key={c.key} className="table-card__row">
                <span className="table-card__label">{c.label}</span>
                <span className="table-card__value">{c.render ? c.render(item) : (item as Record<string, unknown>)[c.key] as React.ReactNode}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}

export default DataTable;
